export function equalSplit(realTotal, count) {
  if (count <= 0) return []
  const base = Math.floor(realTotal / count)
  const remainder = realTotal - base * count
  const result = new Array(count).fill(base)
  result[count - 1] = base + remainder

  return result
}

export function remainingAmount(realTotal, allocated) {
  const sum = allocated.reduce((acc, n) => acc + n, 0)

  return realTotal - sum
}

export function assignRemaining(allocated, index, realTotal) {
  const next = allocated.slice()
  next[index] = (next[index] || 0) + remainingAmount(realTotal, allocated)

  return next
}

export function isValidSplit(realTotal, allocated) {
  if (allocated.length === 0) return false

  return remainingAmount(realTotal, allocated) === 0
}
